import { createRouter, createWebHistory } from 'vue-router'
import store from "@/store";
//import {notification} from "ant-design-vue";



const routes = [{
  path: '/login',
  component: () => import('../views/login.vue')
  },
  {
    path: '/',
    component: () => import('../views/main.vue'),
    meta: {
      loginRequire: true
    },
    children: [{
      path: 'welcome',
      component: () => import('../views/main/welcome.vue'),
    }, {
      path: 'about',
      component: () => import('../views/main/about.vue'),
    },{
      path: 'quotes/',
      children: [{
        path: 'comboquotes',
        component: () => import('../views/main/comboquotes.vue'),
      },{
        path: 'issuedquotes',
        component: () => import('../views/main/rates/issuedquotes.vue'),
      },{
        path: 'fbaCost',
        component: () => import('../components/Comparison/FBA/fbacost.vue'),
      },{
        path: 'tempQuotes',
        component: () => import('../views/main/rates/quotes.vue'),
      },{
        path: 'expbillcheck',
        component: () => import('../components/BillCheck/expbillcheck.vue'),
      },{
        path: 'ratebyuom',
        component: () => import('../components/Quotes/All/rateByUOM.vue'),
      }]
    },{
      path: 'booking/',
      children: [{
        path: 'create/:myParam',
        component: () => import('../views/main/rates/bookcreate.vue'),
        }]
    },{
      path: 'master/',
      children: [{
        path: 'chargecode',
        component: () => import('../views/main/rates/chargecode.vue'),
      },{
        path: 'client',
        component: () => import('../views/main/rates/client.vue'),
      },{
        path: 'globalport',
        component: () => import('../views/main/rates/globalport.vue'),
      },{
        path: 'legcode',
        component: () => import('../views/main/rates/legcode.vue'),
      },{
        path: 'paymentfactor',
        component: () => import('../views/main/rates/paymentfactor.vue'),
      },{
        path: 'vendor',
        component: () => import('../views/main/rates/vendor.vue'),
      }]
    },{
      path: 'e2e/',
      children: [{
        path: 'chassis',
        component: () => import('../views/main/rates/chassis.vue'),
      },{
        path: 'vin',
        component: () => import('../views/main/rates/vin.vue'),
      },{
        path: 'whs',
        component: () => import('../views/main/rates/whs.vue'),
      }]
    },{
      path: 'ratecards/',
      children: [{
        path: 'agentFee',
        component: () => import('../views/main/rates/agentfee.vue'),
      },{
        path: 'allCHB',
        component: () => import('../views/main/rates/allchb.vue'),
      },{
        path: 'drayage',
        component: () => import('../views/main/rates/drayage.vue'),
      },{
        path: 'draysrvfee',
        component: () => import('../views/main/rates/draysrvfee.vue'),
      },{
        path: 'ocean-freight',
        component: () => import('../views/main/rates/oceanfreight.vue'),
      },{
        path: 'originsrvfee',
        component: () => import('../views/main/rates/originsrvfee.vue'),
      },{
        path: 'othc',
        component: () => import('../views/main/rates/othc.vue'),
      },{
        path: 'truckusftl',
        component: () => import('../views/main/rates/truckusftl.vue'),
      },{
        path: 'warehouse',
        component: () => import('../views/main/rates/warehouse.vue'),
      },{
        path: 'explistusa',
        component: () => import('../views/main/rates/explistusa.vue'),
      },{
        path: 'expressups',
        component: () => import('../components/Quotes/express-upload.vue'),
      },{
        path: 'expressfdx',
        component: () => import('../components/Quotes/expfdx-upload.vue'),
      },{
        path: 'expusps',
        component: () => import('../components/Quotes/expusps-upload.vue'),
      }]
    }, {
      path: 'upload/',
      children: [{
        path: 'warehouse',
        component: () => import('../components/Quotes/warehouse-upload.vue')
      },{
        path: 'ocean-freight',
        component: () => import('../components/Quotes/of-upload.vue')
      }]
    },{
      path: 'eTower/',
      children: [{
        path: 'getAPI',
        component: () => import('../components/ETower/eTowerAPI.vue')
      },{
        path: 'quoteInquiry',
        component: () => import('../components/ETower/eTowerQuote.vue')
      },{
        path: 'createOrders',
        component: () => import('../components/ETower/createOrders.vue')
      },{
        path: 'printLabel',
        component: () => import('../components/ETower/printLabel.vue')
      },{
        path: 'tracking',
        component: () => import('../components/ETower/tracking.vue')
      }]
    }, {
      path: 'batch/',
      children: [{
        path: 'job',
        component: () => import('../views/main/batch/job.vue')
      }]
    }]
  },
  {
    path: '',
    redirect: '/welcome'
  }];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 路由登录拦截
router.beforeEach((to, from, next) => {

  // 要不要对meta.loginRequire属性做监控拦截
  if (to.matched.some(function (item) {
    console.log(item, "是否需要登录校验：", item.meta.loginRequire || false);
    return item.meta.loginRequire
  })) {
    const _curUser = store.state.curUser;
    console.log("页面登录校验开始：", _curUser);
    if (!_curUser.token) {
      console.log("用户未登录或登录超时！");
      //notification.error({ description: 'Not Signed In or Time Out!' });
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
